import React from 'react'
import { Flex } from 'pcln-design-system'
import AdBox from './AdBox'
import LayoutComponentWrapper from '../LayoutComponentWrapper'

function AdContent({ children }: { children: React.ReactNode }) {
  return (
    <LayoutComponentWrapper>
      <Flex alignItems="center" justifyContent="center">
        {children}
      </Flex>
    </LayoutComponentWrapper>
  )
}

export { AdContent, AdBox }
